// @ts-nocheck: converted from JS

import NotFound from './NotFound';

export default NotFound;
